
import Menu from './Compartido/Menu.jsx';
// import Banner from './Inicio/Banner.jsx';
// import Destacados from './Inicio/Destacados.jsx';
import Destinos from './Inicio/Destinos.jsx';
// import Mapa from './Inicio/Mapa.jsx';
// import Caracteristicas from './Compartido/Caracteristicas.jsx';
// import Comentarios from './Inicio/Comentarios.jsx';
// import NoticiasHome from './Inicio/NoticiasHome.jsx';
import Footer from './Compartido/Footer.jsx';
import TextoPiePgina from './Inicio/TextoPiePagina.jsx';
//import { ProvidePlugin } from 'webpack';

const Inicio = (props) => {
    return (
        <main>
            {<Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />}
            <Destinos
                destinos={props.destinos}
                ruta={props.ruta}
                config={props.websgrupo}
            />
            <TextoPiePgina
                elementosweb={props.elementosweb}
                lang={props.lang}
                config={props.websgrupo}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default Inicio;
